import { createFileRoute } from "@tanstack/react-router";
import { orpc } from "@/orpc/client";
import { CreateReferralLinkWizard } from "@/pages/app-detail/referral-links/create/CreateReferralLinkWizard";

export const Route = createFileRoute("/_app/apps/$appId/links/create")({
	loader: async ({ context: { queryClient }, params }) => {
		await Promise.all([
			queryClient.ensureQueryData(
				orpc.partners.list.queryOptions({ input: {} }),
			),
			queryClient.ensureQueryData(
				orpc.apps.detail.queryOptions({ input: { id: params.appId } }),
			),
		]);
	},
	head: () => ({
		meta: [{ title: "Create Referral Link - Biteasy" }],
	}),
	component: CreateReferralLinkWizard,
});
